// src/pages/public/ContactPage.jsx

// --- React Hooks ---
import React, { useState } from 'react'; // useState for form data
// No useNavigate, useSelector, etc. needed unless you add form submission logic
// that requires Redux or navigation after submission.

// --- Component Imports ---
import PageWrapper from './PageWrapper'; // The essential wrapper for all pages
import Box from '@mui/material/Box'; // For responsive layout with sx prop

// --- Styles Imports ---
// Import only the specific styles you want to be common to ALL content sections on this page
import {
    colors, // Assuming colors is imported from constants via PageStyles or directly
    introHeadingStyles, // For page title
    introSubHeadingStyles, // For general paragraph text
    // Add other common content styles here as needed
} from 'styles/PageStyles'; // Adjust path based on your setup

// --- Optional: Import form-specific CSS if you have it ---
import 'styles/PageStyles'; // For .form-control styles, including autofill overrides



import { useEffect, useRef, } from 'react';
import { useLocation } from 'react-router-dom';




/**
 * ContactPage: A page component for users to submit inquiries and view contact details.
 */
const ContactPage = () => {

















    const navbarHeight = '4rem';
    const pageRef = useRef(null); // Create a ref for the page's main container

    const location = useLocation();
    useEffect(() => {
        window.scrollTo(100, 0);
    }, [location]); // Run this effect whenever the location changes
















    // State for form data
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: '',
    });

    const { name, email, subject, message } = formData;

    const onChange = e => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const onSubmit = e => {
        e.preventDefault();
        // --- ADD YOUR FORM SUBMISSION LOGIC HERE ---
        // This is where you would typically send the formData to your backend API.
        console.log('Contact Form Submitted:', formData);
        alert('Thank you for your message! We will get back to you shortly.'); // Use a custom modal in production
        // Reset form after submission
        setFormData({
            name: '',
            email: '',
            subject: '',
            message: '',
        });
    };

    // Styles for the main content area, consistent with your TemplatePage
    const mainContentAreaStyles = {
        padding: '20px',
        minHeight: '80vh',
        backgroundColor: 'rgba(0, 0, 0, 0.6)',
        borderRadius: '10px',
        boxShadow: '0 0 20px rgba(0,0,0,0.7)',
        margin: '2rem auto', // Center the content area
        width: '90%',
        maxWidth: '900px',
        color: colors.textColor,
        textAlign: 'center',
    };

    // Styles for the form inputs and labels, derived from your LoginPage
    const formInputStyle = {
        color: 'white',
        backgroundColor: 'black',
        border: '2px solid #006993', // Assuming this color is defined elsewhere or directly in colors
        width: '100%', // Make inputs fill their container
        padding: '10px',
        borderRadius: '5px',
        boxSizing: 'border-box', // Include padding in width
    };

    const formLabelStyle = {
        color: colors.textColor,
        fontSize: '1rem',
        marginBottom: '5px',
        display: 'block', // Make label a block element for better spacing
        textAlign: 'left', // Align label text to the left
    };

    const formGroupStyle = {
        marginBottom: '15px', // Space between form groups
    };

    const submitButtonStyle = {
        backgroundColor: colors.accentColor, // Use your accent color for the button
        color: colors.textColor,
        padding: '10px 20px',
        borderRadius: '5px',
        fontSize: '1rem',
        fontWeight: 'bold',
        cursor: 'pointer',
        border: 'none', // Remove default button border
        marginTop: '20px',
        '&:hover': {
            backgroundColor: colors.accentColor, // Keep same background on hover
            opacity: 0.9, // Slightly dim on hover
            boxShadow: '0 0 10px rgba(255,255,255,0.5)', // Add subtle shadow on hover
        },
    };

    return (
        <PageWrapper navbarPermanent={true}> {/* Contact page typically has a permanent Navbar */}
            <div style={mainContentAreaStyles}>
            <div style={{margin:'2rem'}}></div>
                <h1 style={introHeadingStyles}>Contact Us</h1>

                {/* Contact Form Section */}




                {/* <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column', // Stack form elements vertically
                        alignItems: 'center', // Center the form horizontally
                        gap: '20px', // Space between form sections
                        width: '100%',
                        maxWidth: '600px', // Limit form width for readability
                        margin: '2rem auto', // Center the form block
                        padding: '20px',
                        backgroundColor: 'rgba(0, 0, 0, 0.7)', // Slightly darker background for the form area
                        borderRadius: '8px',
                        boxShadow: '0 0 15px rgba(0,0,0,0.5)',
                        border: '1px solid',
                        borderColor: colors.accentColor,
                    }}
                >
                    <p style={introSubHeadingStyles}>
                        Have a question or want to get involved? Send us a message!
                    </p>

                    <form onSubmit={onSubmit} style={{ width: '100%' }}>
                        <div style={formGroupStyle}>
                            <label style={formLabelStyle} htmlFor='name'>
                                Your Name
                            </label>
                            <input
                                style={formInputStyle}
                                type='text'
                                name='name'
                                onChange={onChange}
                                value={name}
                                required
                            />
                        </div>

                        <div style={formGroupStyle}>
                            <label style={formLabelStyle} htmlFor='email'>
                                Your Email
                            </label>
                            <input
                                style={formInputStyle}
                                type='email'
                                name='email'
                                onChange={onChange}
                                value={email}
                                required
                            />
                        </div>

                        <div style={formGroupStyle}>
                            <label style={formLabelStyle} htmlFor='subject'>
                                Subject
                            </label>
                            <input
                                style={formInputStyle}
                                type='text'
                                name='subject'
                                onChange={onChange}
                                value={subject}
                                required
                            />
                        </div>

                        <div style={formGroupStyle}>
                            <label style={formLabelStyle} htmlFor='message'>
                                Your Message
                            </label>
                            <textarea
                                style={{ ...formInputStyle, minHeight: '120px', resize: 'vertical' }} // Textarea specific styles
                                name='message'
                                onChange={onChange}
                                value={message}
                                required
                            ></textarea>
                        </div>

                        <button type='submit' style={submitButtonStyle}>
                            Send Message
                        </button>
                    </form>
                </Box> */}

















                {/* Contact Details Section */}
                <Box
                    sx={{
                        marginTop: '40px',
                        padding: '20px',
                        backgroundColor: 'rgba(0, 0, 0, 0.7)',
                        borderRadius: '8px',
                        boxShadow: '0 0 15px rgba(0,0,0,0.5)',
                        width: '100%',
                        maxWidth: '600px',
                        margin: '2rem auto',
                        border: '1px solid',
                        borderColor: colors.accentColor,
                    }}
                >
                    <h2 style={introHeadingStyles}>Contact Details</h2>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <div>
                        <p style={{ ...introSubHeadingStyles, textAlign: 'left' }}>
                        <span style={{ color: colors.accentColor, textDecoration: 'none' }}>Email:</span> <a href="mailto:admin@wondermission.org" style={{ color: colors.textColor, textDecoration: 'none' }}>charles@thewondermission.org</a>
                        </p>
                        <p style={{ ...introSubHeadingStyles, textAlign: 'left' }}>
                            <span style={{ color: colors.accentColor, textDecoration: 'none' }}>Phone:</span> <a href="tel:+15085239666" style={{ color: colors.textColor, textDecoration: 'none' }}>(508) 523-9666</a>
                        </p>
                        <p style={{ ...introSubHeadingStyles, textAlign: 'center' }}>
                            <span style={{ color: colors.accentColor, textDecoration: 'none' }}>Address:</span>
                        </p>
                        <p style={{ ...introSubHeadingStyles, textAlign: 'left' }}>
                            The Robert and Esther Goddard House
                        </p>
                        <p style={{ ...introSubHeadingStyles, textAlign: 'left' }}>
                            1 Tallawanda Dr, Worcester, MA 01603
                        </p>
                        </div>

                    </div>





                    {/* You can embed the Google Map here if you want it on the contact page */}
                    {/* <GoogleMapEmbed /> */}
                </Box>
            </div>
        </PageWrapper>
    );
};

export default ContactPage;